import PropTypes from 'prop-types';
import Pagination from 'components/molecules/pagination';

const Footer = ({ setPage, page, count, loading, perPage, itemsLength }) => (
  <div className="adminPanel__footer">
    <Pagination
      title=""
      page={page}
      pageTotal={itemsLength}
      itemsPerPage={perPage}
      total={count}
      handleFirstClick={() => setPage(1)}
      handleLastClick={() => setPage(Math.ceil(count / perPage))}
      handlePrevClick={() => setPage(page - 1)}
      handleNextClick={() => setPage(page + 1)}
      loading={loading}
    />
  </div>
);

Footer.propTypes = {
  setPage: PropTypes.func.isRequired,
  page: PropTypes.number,
  perPage: PropTypes.number,
  loading: PropTypes.bool,
  count: PropTypes.number,
  itemsLength: PropTypes.number,
};

export default Footer;
